export default __webpack_public_path__ + "static/media/blog3-585x390.b7a97243.png";